import {
  CONTACTMANAGER_REQUEST,
  CONTACTMANAGER_SUCCESS,
  CONTACTMANAGER_FAILURE,
  CONTACT_DETAILS_REQUEST,
  CONTACT_DETAILS_SUCCESS,
  CONTACT_DETAILS_FAILURE,
  CLIENT_CONTACTS_REQUEST,
  CLIENT_CONTACTS_SUCCESS,
  CLIENT_CONTACTS_FAILURE,
  LOCATION_CONTACTS_REQUEST,
  LOCATION_CONTACTS_SUCCESS,
  LOCATION_CONTACTS_FAILURE,
  PATIENT_CONTACTS_REQUEST,
  PATIENT_CONTACTS_SUCCESS,
  PATIENT_CONTACTS_FAILURE,
  REFERRAL_CONTACTS_REQUEST,
  REFERRAL_CONTACTS_SUCCESS,
  REFERRAL_CONTACTS_FAILURE,
  FACILITIES_REQUEST,
  FACILITIES_SUCCESS,
  FACILITIES_FAILURE,
  DOCUMENT_TYPES_REQUEST,
  DOCUMENT_TYPES_SUCCESS,
  DOCUMENT_TYPES_FAILURE,
} from './ContactManagerActions';

const initialState = {
  data: [],
  contact: {},
  error: null,
  isLoading: false,
  isUpdating: false,
  contactTypes: null,
  documentTypes: [],
  facilities: null
};

export default function contactManagerReducer(
  state = initialState,
  { type, payload,  },
) {
  switch (type) {
    case CONTACTMANAGER_REQUEST:
      return { ...state, isLoading: true };
    case CONTACTMANAGER_SUCCESS:
      return {
        ...state,
        data: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case CONTACTMANAGER_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CONTACT_DETAILS_REQUEST:
      return { ...state, isLoading: true };
    case CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        contact: payload.data,
        error: null,
        isLoading: false,
      };
    case CONTACT_DETAILS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLIENT_CONTACTS_REQUEST:
      return { ...state, isLoading: true };
    case CLIENT_CONTACTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case CLIENT_CONTACTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case LOCATION_CONTACTS_REQUEST:
      return { ...state, isLoading: true };
    case LOCATION_CONTACTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case LOCATION_CONTACTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_CONTACTS_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_CONTACTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case PATIENT_CONTACTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case REFERRAL_CONTACTS_REQUEST:
      return { ...state, isLoading: true };
    case REFERRAL_CONTACTS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case REFERRAL_CONTACTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case FACILITIES_REQUEST:
      return { ...state, isLoading: true };
    case FACILITIES_SUCCESS:
      return {
        ...state,
        facilities: payload.data,
        contact: {},
        error: null,
        isLoading: false,
      };
    case FACILITIES_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case DOCUMENT_TYPES_REQUEST:
      return { ...state, isLoading: true };
    case DOCUMENT_TYPES_SUCCESS:
      return {
        ...state,
        documentTypes: payload.data,
        errors: null,
        isLoading: false,
      };
    case DOCUMENT_TYPES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/contact-manager/ContactManagerReducer.js